export default "/images/9ad0cff3f1346a487dd25024b889d008.avif";